import React from 'react';

import BaseAlertRoot from 'containers/BaseAlertRoot';
import { getOverlayAlert } from 'api';
import eventTypes from 'constants/eventTypes';
import { OVERLAY_TEMPLATE_COMPONENT_MAP } from 'templateComponentMap';
import { OVERLAY_ROOT_INIT_FUNCTION_MAP } from 'rootInitFunctionMap';

const OverlayAlertRoot = () => (
  <BaseAlertRoot
    templateComponentMap={OVERLAY_TEMPLATE_COMPONENT_MAP}
    templateCallbackMap={OVERLAY_ROOT_INIT_FUNCTION_MAP}
    getAlert={getOverlayAlert}
    eventType={eventTypes.SHOW_OVERLAY}
  />
);

export default OverlayAlertRoot;
